/**
 * Leaf module: path strings + classification only. NO component imports and
 * NO transitive dependencies on `pages/*`, so it is safe to import from the
 * App bootstrap (or anywhere) without pulling in the auth-page bundle.
 *
 * The `<Route>` component bindings live in `AppRouter.tsx`.
 */

export const UNAUTHENTICATED_ROUTE_PATHS: readonly string[] = [
    'login',
    'forgot-password',
    'recover-username',
    'reset-password',
    'welcome'
];

const UNAUTHENTICATED_PATH_PATTERN = new RegExp(
    '^/(' + UNAUTHENTICATED_ROUTE_PATHS.join('|') + ')(/|$)',
    'i'
);

export type RouteKind = 'unauthenticated' | 'protected';

export const classify = (pathname: string): RouteKind => (
    UNAUTHENTICATED_PATH_PATTERN.test(pathname) ? 'unauthenticated' : 'protected'
);

export const isUnauthenticatedRoutePath = (pathname: string): boolean => (
    classify(pathname) === 'unauthenticated'
);
